module.exports = __webpack_public_path__ + "static/cosyelephant2-e78b2e726d37cd1b906daee94506a629.png";